// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"891":"4e2f1d53","894":"b7bb8c6d"}[chunkId] + ".chunk.css";
};